import {Component, EventEmitter, Input, Output} from '@angular/core';
import {NgClass} from '@angular/common';
import {MatIcon} from '@angular/material/icon';
import {MethodsUtils} from '../shared/util/methods.utils';
import {Router} from '@angular/router';
import { Location } from '@angular/common';

@Component({
  selector: 'app-titulo',
  imports: [
    NgClass,
    MatIcon
  ],
  templateUrl: './titulo.component.html',
  styleUrl: './titulo.component.css'
})
export class TituloComponent {
  @Input() foraAppComponent: boolean = false;
  @Input() confirmarRetorno: boolean = false;
  @Input() backRotina: boolean = false;
  @Input() rotinaRetorno?: string;
  @Input() titulo?: string;
  @Output() cancelarEmit = new EventEmitter();

  constructor(
    private location: Location,
    private router: Router,
  ) {  }

  voltar(){
    if (!this.confirmarRetorno || window.confirm('Pode possuir alterações não salvas, deseja fechar?')) {
      this.retornar(true);
    }
  }

  retornar(podeRetornar: boolean) {
    if (podeRetornar) {
      if (!this.backRotina) {
        if (this.rotinaRetorno) {
          this.router.navigate([this.rotinaRetorno]);
        } else {
          this.location.back();
        }
      } else {
        this.cancelarEmit.emit()
      }
    }
  }

  get isMobile() {
    return MethodsUtils.detectar_mobile();
  }
}
